import React from 'react';
import styles from './BooleanRadio.module.css';

interface BooleanRadioProps {
  name: string;
  value: boolean | null;
  onChange: (value: boolean) => void;
  disabled?: boolean;
  error?: string;
  trueLabel?: string;
  falseLabel?: string;
  className?: string;
}

const BooleanRadio: React.FC<BooleanRadioProps> = ({
  name,
  value,
  onChange,
  disabled = false,
  error,
  trueLabel = 'Sim',
  falseLabel = 'Não',
  className = '',
}) => (
  <div>
    <div className={`${styles.radioGroup} ${className}`}>
      <label className={styles.radioLabel}>
        <input
          type="radio"
          name={name}
          checked={value === true}
          onChange={() => onChange(true)}
          disabled={disabled}
        />
        {trueLabel}
      </label>
      <label className={styles.radioLabel}>
        <input
          type="radio"
          name={name}
          checked={value === false}
          onChange={() => onChange(false)}
          disabled={disabled}
        />
        {falseLabel}
      </label>
    </div>
    {error && <span className={styles.errorText}>{error}</span>}
  </div>
);

export default BooleanRadio;

export interface ChoiceRadioOption<T extends string> {
  value: T;
  label: string;
}

interface ChoiceRadioProps<T extends string> {
  name: string;
  value: T | null;
  options: ReadonlyArray<ChoiceRadioOption<T>>;
  onChange: (value: T) => void;
  disabled?: boolean;
  className?: string;
}

export function ChoiceRadio<T extends string>({
  name,
  value,
  options,
  onChange,
  disabled = false,
  className = '',
}: ChoiceRadioProps<T>) {
  return (
    <div className={`${styles.radioGroup} ${className}`}>
      {options.map((option) => (
        <label key={option.value} className={styles.radioLabel}>
          <input
            type="radio"
            name={name}
            checked={value === option.value}
            onChange={() => onChange(option.value)}
            disabled={disabled}
          />
          {option.label}
        </label>
      ))}
    </div>
  );
}
